/**
 * Site-wide toast notification system
 * Displays toast messages from Redux store using Meridian Alert component
 */

import React, { useEffect } from 'react';
import Alert from '@amzn/meridian/alert';
import { useAppSelector, useAppDispatch } from '../../../store/store';
import { removeToast } from '../../../store/toastsSlice';

const SiteToaster: React.FC = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector((state) => state.toasts.toasts);

  // Auto-dismiss toasts with duration
  useEffect(() => {
    toasts.forEach((toast) => {
      if (toast.duration) {
        const timer = setTimeout(() => {
          dispatch(removeToast(toast.id));
        }, toast.duration);

        return () => clearTimeout(timer);
      }
    });
  }, [toasts, dispatch]);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '80px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        maxWidth: '400px',
      }}
    >
      {toasts.map((toast) => (
        <div key={toast.id} style={{ position: 'relative' }}>
          <Alert
            type={toast.type === 'error' ? 'error' : 
                  toast.type === 'warning' ? 'warning' : 
                  toast.type === 'success' ? 'success' : undefined}
          >
            {toast.message}
          </Alert>
          {toast.dismissible && (
            <button
              onClick={() => dispatch(removeToast(toast.id))}
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#666',
                lineHeight: 1,
                padding: '4px',
              }}
              aria-label="Dismiss"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default SiteToaster;
